module.exports = __webpack_public_path__ + "img/icon-warning-snøskred-4.5fa08009.svg";